import { render } from "./rentalobjecttemplate.vue?vue&type=template&id=48a1c30f"
import script from "./rentalobjecttemplate.vue?vue&type=script&lang=js"
export * from "./rentalobjecttemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__